import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import './AddLoan.scss';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
import 'date-fns';
import Slider from '@material-ui/core/Slider';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {BaseUrl} from "../../../Environment";
import { withNamespaces } from 'react-i18next';
import { getSecureItem } from '../../../utilsFunctions';
import {withRouter} from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import searchicon from '../../../assets/images/searchicon.svg';

const axios = require('axios')

class AddLoan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      changeColorname: '1px solid #D4D4D5',
      changeColornumber: '1px solid #D4D4D5',
      
      changeColoremail: '1px solid #D4D4D5',
      changeColorcategory: '1px solid #D4D4D5',
      changeColoremail5: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      previousOverDueAmount:"",
      previousLoanId:"",
      closingDate:"",
      category: "collector",
      collectionagent: "",
      SelectedDate: new Date(),
      amountvalues: 0,
      tenurevalues: 0,
      interestvalues: 0,
      processFee: "",
      feedetails: [],
      feeValues: {},
      totalFee: 0,
      brands: [{ id: 1, name: "Monthly" }, { id: 2, name: "Weekly" }, { id: 3, name: "BiWeekly" }, { id: 4, name: "Daily" }, { id: 5, name: "Ten_Daily" }],
      monthlyRange: "",
      weeklyRange: "",
      dailyRange: "",
      minValue: 0,
      maxValue: 0,
      step: 1,
      mintenureValue: 0,
      maxtenureValue: 0,
      steptenure: 1,
      mininterestValue: 0,
      maxinterestValue: 0,
      stepinterest: 1,
      LaonType:[],
      allCustomer:[],
      loanTypeId: "",
      amountfrom: 0,
      amountto: 0,
      mintenureDaysValue: 0,
      maxtenureDaysValue: 0,
      mintenureWeekValue: 0,
      maxtenureWeekValue: 0,
      mintenureMonthValue: 0,
      maxtenureMonthValue: 0,
      // monthsfrom: 0,
      // monthsto: 0,
      // rateofInterestfrom:0,
      // rateofInterestto:0,
      tenure: "Monthly",
      collectionArr: [],
      scheduleArr: [],
      userdetails: [],
      userdetailPostLoan:[],
      collectionagent: "",
      valueAftermoratorium:"",
      rows: [],
      moratorium:"0",
      flexiBlocksUsed: null,
      totalInterest: 0,
      collectionAmount:"",
      isdisabled:true,
      searchdone:false,
      customerId: "",
      coApplicantCustomerId: null,
      guarantorCustomerId: null,
      chooseBorrower: "",
      chooseCoApplicant: "",
      chooseGuarantor: "",
      allBorrower: [],
      allCoApplicant: [],
      allGuarantor: [],
      showBorrowerDropdown: false,
      showCoApplicantDropdown: false,
      showGuarantorDropdown: false,
      searchdoneBorrower: false,
      searchdoneCoApplicant: false,
      searchdoneGuarantor: false,
    };
    this.nameBox = this.nameBox.bind(this)
    this.numberBox = this.numberBox.bind(this)
    this.emailBox = this.emailBox.bind(this)
    this.categoryBox = this.categoryBox.bind(this)
    this.emailBox7 = this.emailBox7.bind(this)
    this.emailBox6 = this.emailBox6.bind(this)
    this.emailBox5 = this.emailBox5.bind(this)
    this.emailBox4 = this.emailBox4.bind(this)
    this.emailBox3 = this.emailBox3.bind(this)
    this.calculationwithnointerest = this.calculationwithnointerest.bind(this)
    this.borrowerWrapperRef = React.createRef();
    this.coApplicantWrapperRef = React.createRef();
    this.guarantorWrapperRef = React.createRef();
  }


  searchSubmit = (e) => {
    document.getElementById('test1').addEventListener("change", function () {
      document.getElementById('test2').selectedIndex = document.getElementById('test1').selectedIndex;
  }, false);
  document.getElementById('test2').addEventListener("change", function () {
      document.getElementById('test1').selectedIndex = document.getElementById('test2').selectedIndex;
  }, false);
    const { value } = e.target;
    if (parseInt(value) === 1) {
      this.setState({
        monthlyRange: "",
        weeklyRange: "none",
        dailyRange: "none",
        tenure: "Monthly",
        mintenureValue:this.state.mintenureMonthValue,
        maxtenureValue:this.state.maxtenureMonthValue,
      })
    } else if (parseInt(value) === 2) {
      this.setState({
        monthlyRange: "none",
        weeklyRange: "",
        dailyRange: "none",
        tenure: "Weekly",
        mintenureValue: this.state.mintenureWeekValue,
        maxtenureValue: this.state.maxtenureWeekValue,
      })
    } else if (parseInt(value) === 3) {
      this.setState({
        monthlyRange: "none",
        weeklyRange: "",
        dailyRange: "none",
        tenure: "BiWeekly",
        mintenureValue: this.state.mintenureWeekValue,
        maxtenureValue: this.state.maxtenureWeekValue,
      })
    } else if (parseInt(value) === 5) {
      this.setState({
        monthlyRange: "none",
        weeklyRange: "",
        dailyRange: "none",
        tenure: "Ten_Daily",
        mintenureValue: this.state.mintenureDaysValue,
        maxtenureValue: this.state.maxtenureDaysValue,
      })
    } else {
      this.setState({
        monthlyRange: "none",
        weeklyRange: "none",
        dailyRange: "",
        tenure: "Daily",
        mintenureValue: this.state.mintenureDaysValue,
        maxtenureValue: this.state.maxtenureDaysValue,
      })
    }
    this.props.TableData([],this.state.collectionagent,true);
  }  

  handleChange = event => {
    this.setState({ category: event.target.value,isdisabled:true });
    this.props.TableData(this.state.scheduleArr,this.state.collectionagent,this.state.isdisabled);
  };
  nameBox() {
    this.setState({
      changeColorname: "1px solid #00D95E",
      changeColornumber: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
    })
  }
  numberBox() {
    this.setState({
      changeColornumber: "1px solid #00D95E",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
    })
  }
  emailBox() {
    this.setState({
      changeColoremail: "1px solid #00D95E",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
    })
  }
  categoryBox() {
    this.setState({
      changeColorcategory: "1px solid #00D95E",
      changeColoremail: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
    })
  }
  emailBox6() {
    this.setState({
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail7: "1px solid #D4D4D5",
      changeColoremail6: "1px solid #00D95E",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
    });
  }
  emailBox7() {
    this.setState({
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail7: "1px solid #00D95E",
      changeColoremail6: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
    });
  }
  emailBox5() {
    this.setState({
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #00D95E",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail6: "1px solid #D4D4D5",
      changeColoremail7: "1px solid #D4D4D5",
    })
  }
  emailBox3() {
    this.setState({
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #00D95E",
      changeColoremail4: "1px solid #D4D4D5",
    })
  }
  emailBox4() {
    this.setState({
      changeColorcategory: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      // changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #00D95E",
    })
  }
  // back(){
  //     window.history.back();
  //   }

  handleDateChange = (date) => {
    this.setState({
      SelectedDate: date
    })
    this.props.TableData([],this.state.collectionagent,true);
  };
  componentDidMount() {
    if(this.props?.customerId){
      this.setState({
        customerId: this.props?.customerId,
        chooseBorrower: this.props?.chooseBorrower,
      })
    }
    if (this.props?.coApplicantCustomerId) {
      this.setState({
        coApplicantCustomerId: this.props?.coApplicantCustomerId,
        chooseCoApplicant: this.props?.chooseCoApplicant,
      })
    }
    if (this.props?.guarantorCustomerId) {
      this.setState({
        guarantorCustomerId: this.props?.guarantorCustomerId,
        chooseGuarantor: this.props?.chooseGuarantor,
      })
    }
    
    this.setState({
      monthlyRange: "",
      weeklyRange: "none",
      dailyRange: "none",
      searchdone:false
    })
    this.AllLoanTypeList(() => {
      if (this.props.replanLoanDetails) {
        this.applyReplanLoanDetails(this.props.replanLoanDetails,this.props.previousOverDueAmount,this.props.previousLoanId);
      }
    });
    this.getAllFees();
    this.props.onRef(this)
    this.props.TableData([],"",false);
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  reverseTenureMap = {
    monthly: "Monthly",
    weekly: "Weekly",
    biweekly: "BiWeekly",
    daily: "Daily",
    ten_daily: "Ten_Daily",
  };

  applyReplanLoanDetails = (loanDetails,previousOverDueAmount,previousLoanId) => {
    if (!loanDetails) return;

    const customer = loanDetails.customer || {};
    const matchedLoanType = this.state.LaonType.find(
      (item) => item.loanTypeId === loanDetails.loanTypeId
    );

    const tenureKey = (loanDetails.loanTenureType || "monthly").toLowerCase();
    const tenureLabel = this.reverseTenureMap[tenureKey] || "Monthly";

    const rangeVisibility = {
      monthlyRange: tenureLabel === "Monthly" ? "" : "none",
      weeklyRange: (tenureLabel === "Weekly" || tenureLabel === "BiWeekly") ? "" : "none",
      dailyRange: (tenureLabel === "Daily" || tenureLabel === "Ten_Daily") ? "" : "none",
    };

    const tenureBoundsByLabel = {
      Monthly: {
        mintenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureMonthsFrom) : 0,
        maxtenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureMonthsTo) : 0,
      },
      Weekly: {
        mintenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureWeeksFrom) : 0,
        maxtenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureWeeksTo) : 0,
      },
      BiWeekly: {
        mintenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureWeeksFrom) : 0,
        maxtenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureWeeksTo) : 0,
      },
      Daily: {
        mintenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureDaysFrom) : 0,
        maxtenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureDaysTo) : 0,
      },
      Ten_Daily: {
        mintenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureDaysFrom) : 0,
        maxtenureValue: matchedLoanType ? parseInt(matchedLoanType.tenureDaysTo) : 0,
      },
    };

    this.setState(
      {
        // laontype: matchedLoanType ? matchedLoanType.loanType : "",
        // loanTypeId: loanDetails.loanTypeId,

        // minValue: matchedLoanType ? parseInt(matchedLoanType.loanAmtRangeFrom) : 0,
        // maxValue: matchedLoanType ? parseInt(matchedLoanType.loanAmtRangeTo) : 0,
        // mintenureDaysValue: matchedLoanType ? parseInt(matchedLoanType.tenureDaysFrom) : 0,
        // maxtenureDaysValue: matchedLoanType ? parseInt(matchedLoanType.tenureDaysTo) : 0,
        // mintenureWeekValue: matchedLoanType ? parseInt(matchedLoanType.tenureWeeksFrom) : 0,
        // maxtenureWeekValue: matchedLoanType ? parseInt(matchedLoanType.tenureWeeksTo) : 0,
        // mintenureMonthValue: matchedLoanType ? parseInt(matchedLoanType.tenureMonthsFrom) : 0,
        // maxtenureMonthValue: matchedLoanType ? parseInt(matchedLoanType.tenureMonthsTo) : 0,
        // mininterestValue: matchedLoanType ? parseInt(matchedLoanType.roiFrom) : 0,
        // maxinterestValue: matchedLoanType ? parseInt(matchedLoanType.roiTo) : 0,

        // tenure: tenureLabel,
        // ...rangeVisibility,
        // ...(tenureBoundsByLabel[tenureLabel] || {}),

        // amountvalues: Number(loanDetails.loanAmount) || 0,
        // tenurevalues: Number(loanDetails.loanTenure) || 0,
        // interestvalues: Number(loanDetails.rateOfInterest) || 0,
        // moratorium: String(loanDetails.moratoriumPeriods ?? "0"),
        // collectionAmount: loanDetails.collectionAmount || "",
        // valueAftermoratorium: loanDetails.totalAmountToCollect || "",
        // SelectedDate: loanDetails.startDate ? new Date(loanDetails.startDate) : new Date(),

        previousOverDueAmount: previousOverDueAmount,
        previousLoanId: previousLoanId,
        closingDate:this.props.closingDate,

        customerId: loanDetails.customerId,
        coApplicantCustomerId: loanDetails.coApplicantCustomerId || null,
        guarantorCustomerId: loanDetails.guarantorCustomerId || null,
        chooseBorrower: customer.cust_id
          ? `${customer.firstName} ${customer.lastName} (${customer.cust_id})`
          : `${customer.firstName || ""} ${customer.lastName || ""}`.trim(),

        isdisabled: true,
        rows: [],
      },
      () => {
        this.props.TableData([], this.state.collectionagent, true);
      }
    );
  };

  componentWillUnmount() {
    this.props.onRef(null)
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.borrowerWrapperRef?.current && !this.borrowerWrapperRef.current.contains(event.target)) {
      this.setState({ showBorrowerDropdown: false });
    }
    if (this.coApplicantWrapperRef?.current && !this.coApplicantWrapperRef.current.contains(event.target)) {
      this.setState({ showCoApplicantDropdown: false });
    }
    if (this.guarantorWrapperRef?.current && !this.guarantorWrapperRef.current.contains(event.target)) {
      this.setState({ showGuarantorDropdown: false });
    }
  };
  handleBlur = () => {
    // if (amountvalue < 0) {
    //   setValue(0);
    // } else if (amountvalue > 100) {
    //   setValue(100);
    // }
  };
  handleInputChange = event => {
    this.setState({
      amountvalues: event.target.value === '' ? '' : Number(event.target.value),
      isdisabled: true,
      rows: [],
      // maxValue:event.target.value === '' ? 0 :parseInt(event.target.value)
    }, () => {
      this.recalculateFeesFromLoanAmount();
      this.props.TableData([], this.state.collectionagent, true);
    });
  };  
  handleSliderChange = (event, newValue) => {
    this.setState({
      amountvalues: newValue,
      isdisabled: true,
      rows: [],
    }, () => {
      this.recalculateFeesFromLoanAmount();
      this.props.TableData([], this.state.collectionagent, true);
    });
  };
  onMoratoriumChange = (event,value) => {
    this.setState({
     moratorium:event.target.value
    })
    console.log(this.state.moratorium);
    this.props.TableData([],this.state.collectionagent,true);
  };
  handleSlidertenureChange = (event, newValue) => {
    this.setState({
      tenurevalues: newValue
    })
    this.props.TableData([],this.state.collectionagent,true);
  }
  handleInputtenureChange = event => {
    this.setState({
      tenurevalues: event.target.value === '' ? '' : Number(event.target.value),
      // maxtenureDaysValue:event.target.value === '' ? 0 :parseInt(event.target.value),
      // maxtenureMonthValue:event.target.value === '' ? 0 :parseInt(event.target.value),
      // maxtenureWeekValue:event.target.value === '' ? 0 :parseInt(event.target.value),
      // maxtenureValue:event.target.value === '' ? 0 :parseInt(event.target.value),

    })
    this.props.TableData([],this.state.collectionagent,true);
  }
  handleInputinterestChange = event => {
    this.setState({
      interestvalues: event.target.value === '' ? '' : Number(event.target.value),
      // maxinterestValue:event.target.value === '' ? 0 :parseInt(event.target.value),
    })
    this.props.TableData([],this.state.collectionagent,true);
  }
  handleSliderinterestChange = (event, newValue) => {
    console.log("event",event.target.value)
    console.log("newvalue",newValue)
    console.log("this.state.interestvalues",this.state.interestvalues)
    this.setState({
      interestvalues: newValue
    })
    this.props.TableData([],this.state.collectionagent,true);
  }
  createData(Month, Opening, Amt, Principal, Interest, Closing, Due) {
    return { Month, Opening, Amt, Principal, Interest, Closing, Due };
  }
  handleCustomerInputChange = (event, type) => {
    const value = event.target.value;

    this.setState({
      [`choose${type}`]: value,
      [`show${type}Dropdown`]: false,
      [`all${type}`]: [],
      isdisabled: true,
      rows: [],
      ...(type === "Borrower" && { customerId: "" }),
      ...(type === "CoApplicant" && { coApplicantCustomerId: null }),
      ...(type === "Guarantor" && { guarantorCustomerId: null }),
    });
  };

  triggerCustomerSearch = (type) => {
    const loggedinUser = getSecureItem("loggedinUser");
    const value = (this.state[`choose${type}`] || "").trim();

    this.setState({
      [`show${type}Dropdown`]: false,
      [`all${type}`]: [],
      isdisabled: true,
      rows: [],
    });

    if (!value) {
      this.setState({ [`choose${type}`]: "" });
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };

    axios
      .get(
        `${BaseUrl}/customer/getVerifiedCustomers?name=${encodeURIComponent(value)}&companyId=${loggedinUser.companyId}&branchId=${loggedinUser?.userType === "superAdmin" ? "" : loggedinUser.branchId || ""}`,
        { headers }
      )
      .then((resp) => {
        if (resp.status === 200) {
          this.setState({
            [`all${type}`]: resp.data,
            [`show${type}Dropdown`]: resp.data.length > 0,
            [`searchdone${type}`]: resp.data.length === 0,
          });
          if (resp.data.length <= 0) {
            this.setState({ [`choose${type}`]: "" });
          }
        } else {
          toast.error("Please try again!");
        }
      })
      .catch(() => toast.error("Please try again!"));
  };

  selectName = (selectedData, type) => {
    if (type === "Borrower") {
      this.setState({
        chooseBorrower: selectedData.cust_id
          ? `${selectedData.firstName} ${selectedData.lastName} (${selectedData.cust_id})`
          : `${selectedData.firstName} ${selectedData.lastName}`,
        customerId: selectedData.customerId, // <-- Ensure this is set!
        showBorrowerDropdown: false,
        isdisabled: true,
        rows: [],
        searchdoneBorrower: false,
      });
    } else if (type === "CoApplicant") {
      this.setState({
        chooseCoApplicant: selectedData.cust_id
          ? `${selectedData.firstName} ${selectedData.lastName} (${selectedData.cust_id})`
          : `${selectedData.firstName} ${selectedData.lastName}`,
        coApplicantCustomerId: selectedData.customerId,
        showCoApplicantDropdown: false,
        isdisabled: true,
        rows: [],
        searchdoneCoApplicant: false,
      });
    } else if (type === "Guarantor") {
      this.setState({
        chooseGuarantor: selectedData.cust_id
          ? `${selectedData.firstName} ${selectedData.lastName} (${selectedData.cust_id})`
          : `${selectedData.firstName} ${selectedData.lastName}`,
        guarantorCustomerId: selectedData.customerId,
        showGuarantorDropdown: false,
        isdisabled: true,
        rows: [],
        searchdoneGuarantor: false,
      });
    }
  };

  renderDropdown = (data, type) => {
    const hasValidSelection = type === "Borrower"
      ? !!this.state.customerId
      : type === "CoApplicant"
        ? !!this.state.coApplicantCustomerId
        : !!this.state.guarantorCustomerId;

    return data.length > 0 && this.state[`show${type}Dropdown`] ? (
      <div
        style={{
          position: "absolute",
          top: "calc(100% + 6px)",
          left: 0,
          width: "100%",
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: "8px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
          maxHeight: "260px",
          overflowY: "auto",
          zIndex: 9999,
        }}
      >
        {data.map((option) => (
          <div
            key={option.customerId || option.cust_id}
            onMouseDown={() => this.selectName(option, type)}
            style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #F3F3F3" }}
          >
            <div style={{ fontSize: "14px", fontWeight: 500, color: "#212121" }}>
              {option.firstName} {option.lastName}
            </div>
            <div style={{ marginTop: "2px", fontSize: "12px", color: "#8C8C8C" }}>
              {option.cust_id}{option.phone ? ` • ${option.phone}` : ""}
            </div>
          </div>
        ))}
      </div>
    ) : (
      this.state[`searchdone${type}`] && !hasValidSelection && (
        <div className="errorMsg">Choose a valid {type?.toLowerCase()}</div>
      )
    );
  };
  LoanChange = (event) => {
    this.setState({
      laontype: event.target.value
    })
    this.state.LaonType.map((item) => {
      if (event.target.value === item.loanType) {
        this.setState({
          loanTypeId: item.loanTypeId,
          minValue: parseInt(item.loanAmtRangeFrom),
          maxValue: parseInt(item.loanAmtRangeTo),
          mintenureDaysValue: parseInt(item.tenureDaysFrom),
          maxtenureDaysValue: parseInt(item.tenureDaysTo),
          mintenureWeekValue: parseInt(item.tenureWeeksFrom),
          maxtenureWeekValue: parseInt(item.tenureWeeksTo),
          mintenureMonthValue: parseInt(item.tenureMonthsFrom),
          maxtenureMonthValue: parseInt(item.tenureMonthsTo),
          mintenureValue: parseInt(item.tenureMonthsFrom),
          maxtenureValue: parseInt(item.tenureMonthsTo),
          mininterestValue:parseInt(item.roiFrom),
          maxinterestValue:parseInt(item.roiTo),
        })
      }
    })
    this.props.TableData([],this.state.collectionagent,true);
  }
  betweenRange = () => {
    if (this.state.chooseBorrower) {
if(this.state.interestvalues >= this.state.mininterestValue && this.state.interestvalues <=this.state.maxinterestValue){
    if ((this.state.amountvalues >= parseInt(this.state.minValue)) && (this.state.amountvalues <= parseInt(this.state.maxValue))) {
      if (this.state.tenure === "Monthly") {
        if (this.state.tenurevalues >= this.state.mintenureMonthValue && this.state.tenurevalues <= this.state.maxtenureMonthValue) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "Weekly") {
        if (this.state.tenurevalues >= this.state.mintenureWeekValue && this.state.tenurevalues <= this.state.maxtenureWeekValue) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "BiWeekly") {
        if (this.state.tenurevalues >= this.state.mintenureWeekValue && this.state.tenurevalues <= this.state.maxtenureWeekValue) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "Daily") {
        if (this.state.tenurevalues >= this.state.mintenureDaysValue && this.state.tenurevalues <= this.state.maxtenureDaysValue) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "Ten_Daily") {
        if (this.state.tenurevalues >= this.state.mintenureDaysValue && this.state.tenurevalues <= this.state.maxtenureDaysValue) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      }
    } else {
      toast.error("Loan Amount must be in range", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      });
    }
  }
  else{
    toast.error("Rate of Interest must be in Range", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
    }); 
  }
}
 else{
        toast.error("Choose Borrower to Assign Loan!!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      }); 
    }
  }

  calculationwithnointerest() {
    if (this.props.method === "Flexi EMI") {
      return this.calculateFlexi();
    }
    return this.calculateEmiMethod();
  }

  calculateFlexi() {
    let loggedinUser = getSecureItem("loggedinUser");
    this.state.userdetails = {
      loanAmount: this.state.amountvalues.toFixed(2),
      rateOfInterest: this.state.interestvalues.toFixed(2),
      periods: this.state.tenurevalues.toFixed(2),
      startDate: this.state.SelectedDate,
      processFee: parseInt(this.state.processFee || "0"),
      feeDetailsJson: { ...this.state.feeValues },
      companyId: loggedinUser.companyId,
      // no moratoriumMonths — Flexi doesn't use it
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };

    axios.post(BaseUrl + "/loan/calculateFlexiEmi", this.state.userdetails, { headers })
      .then((resp) => {
        const data = resp.data.loanSchedules;

        this.state.scheduleArr = data.map((item) => ({
          ...item,
          openingBalance: item.openingBalance,
          scheduledDate: item.scheduledDate,
          loanTenure: parseInt(this.state.tenurevalues),
          closingBalance: item.closingBalance,
          collectionAmount: item.EMI,
          createdByUserId: getSecureItem("userid"),
          updatedByUserId: getSecureItem("userid"),
          customerId: this.state.customerId,
          companyId: loggedinUser.companyId,
          interest: item.interest,
          EMI: item.EMI,
          principal: item.principal,
          blockPrincipalPercent: item.blockPrincipalPercent,
        }));

        this.state.collectionArr = data.map((item, index) => ({
          dueDate: item.scheduledDate,
          nextSchedule: data.length === index + 1 ? data[index].scheduledDate : data[index + 1].scheduledDate,
          Installment: item.EMI,
          collectionAmount: item.EMI,
          openingBalance: item.openingBalance,
          closingBalance: item.closingBalance,
          collectionStatus: null,
          PenaltyApplied: null,
          createdByUserId: getSecureItem("userid"),
          updatedByUserId: getSecureItem("userid"),
          customerId: this.state.customerId,
          companyId: loggedinUser.companyId,
          interest: item.interest,
          principal: item.principal,
        }));

        if (resp.request.status === 200) {
          this.setState({
            rows: this.state.scheduleArr,
            isdisabled: false,
            flexiBlocksUsed: resp.data.flexiBlocksUsed,
            collectionAmount: data[0].EMI,
            totalInterest: resp.data.totalInterest,
          });
          this.props.TableData(this.state.scheduleArr, this.state.collectionagent, this.state.isdisabled);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          toast.error(err.response.data.message, { position: "top-center", autoClose: 3000, hideProgressBar: true });
        } else {
          toast.error("Please fill correct data!", { position: "top-center", autoClose: 2000, hideProgressBar: true });
        }
      });
  }

  calculateEmiMethod() {
    let loggedinUser = getSecureItem("loggedinUser")
    this.state.userdetails = {
      "loanAmount":this.state.amountvalues.toFixed(2),
      "rateOfInterest":this.state.interestvalues.toFixed(2),
      "moratoriumMonths":parseInt(this.state.moratorium).toFixed(2),
      "periods":this.state.tenurevalues.toFixed(2),
      "startDate":this.state.SelectedDate,
      "processFee": parseInt(this.state.processFee || "0"),
      "feeDetailsJson": { ...this.state.feeValues },
      "companyId": loggedinUser.companyId,
    }
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ getSecureItem("token")
    }
    axios.post(BaseUrl + '/loan/calculateEmi', this.state.userdetails, {
      headers: headers,
    }).then(resp => {
      this.state.scheduleArr = resp.data.map((item) => ({
        ...item,
        openingBalance: item.openingBalance,
        scheduledDate: item.scheduledDate,
        loanTenure: parseInt(this.state.tenurevalues),
        closingBalance: item.closingBalance,
        collectionAmount: item.EMI,
        createdByUserId: getSecureItem("userid"),
        updatedByUserId: getSecureItem("userid"),
        customerId: this.state.customerId,
        companyId: loggedinUser.companyId,
        interest:item.interest,
        EMI:item.EMI,
        principal:item.principal 
      }))

      this.state.collectionArr = resp.data.map((item, index) => (
        {
          dueDate: item.scheduledDate,
          nextSchedule: resp.data.length === (index + 1) ? resp.data[index].scheduledDate : resp.data[(index + 1)].scheduledDate,
          Installment: item.EMI,
          collectionAmount: item.EMI,
          openingBalance: item.openingBalance,
          closingBalance: item.closingBalance,
          collectionStatus: null,
          PenaltyApplied: null,
          createdByUserId: getSecureItem("userid"),
          updatedByUserId: getSecureItem("userid"),
          customerId: this.state.customerId,
          "companyId": loggedinUser.companyId,
          interest:item.interest,
          principal:item.principal   
        }
      ))
      if (resp.request.status === 200) {
        this.setState({
          rows: this.state.scheduleArr,
          isdisabled:false
        })
        let LastData = resp.data[resp.data.length-1]
        this.setState({
          valueAftermoratorium:LastData.valueafterMoratorium,
          collectionAmount:LastData.EMI
        })
        this.props.TableData(this.state.scheduleArr,this.state.collectionagent,this.state.isdisabled);
      }
    }).catch(err => {
      if(err.request.status===401){
        toast.error(err.response.data.message, {
          position: "top-center", autoClose: 3000, hideProgressBar: true,
          closeOnClick: true, pauseOnHover: false, draggable: true,
        });
      } else {
        toast.error("Please fill correct data!", {
          position: "top-center", autoClose: 2000, hideProgressBar: true,
          closeOnClick: true, pauseOnHover: false, draggable: true,
        });
      }
    })
    this.setState({
      totalAmount: this.state.loantenure * this.state.installment
    })
  }

  postLoan=()=>{
    this.postLoanwithInterest()
  }
  postLoanwithInterest = () => {
    if (this.state.chooseBorrower && this.state.collectionagent) {
      let loggedinUser = getSecureItem("loggedinUserCompany");
      const isFlexi = this.props.method === "Flexi EMI";

      this.state.collectionArr.forEach((item, index) => {
        this.state.collectionArr[index].collectorId = this.state.collectionagent;
      });
      this.state.scheduleArr.forEach((item, index) => {
        this.state.scheduleArr[index].collectorId = this.state.collectionagent;
      });

      const totalAmountToCollect = isFlexi
        ? this.state.scheduleArr.reduce((sum, r) => sum + Number(r.EMI || 0), 0)
        : this.state.tenurevalues * parseInt(this.state.collectionAmount);

      const userdetailPostLoan = {
        loanTypeId: this.state.loanTypeId,
        method: isFlexi ? "Flexi EMI" : "EMI Method",
        penalty: 0,
        loancollections: this.state.collectionArr,
        loanAmount: parseInt(this.state.amountvalues),
        loanTenureType: "monthly",
        loanTenure: parseInt(this.state.tenurevalues),
        collectionAmount: parseInt(this.state.collectionAmount),
        totalAmountToCollect,
        processFee: parseInt(this.state.processFee || "0"),
        feeDetailsJson: { ...this.state.feeValues },
        customerId: this.state.customerId,
        coApplicantCustomerId: this.state.coApplicantCustomerId,
        guarantorCustomerId: this.state.guarantorCustomerId,
        loanStatus: "Open",
        createdByUserId: getSecureItem("userid"),
        updatedByUserId: getSecureItem("userid"),
        companyId: loggedinUser,
        loanSchedules: this.state.scheduleArr,
        moratoriumPeriods: isFlexi ? 0 : this.state.moratorium, // Flexi has none
        collectorId: this.state.collectionagent,
        loanPaymentStatus: "Due",
        nextDueDate: this.state.SelectedDate,
        startDate: this.state.SelectedDate,
        rateOfInterest: this.state.interestvalues,
        lastCollectedDate: this.props.closingDate,
        updatedAt: this.props.closingDate,
        previousLoanAmount: this.props.previousOverDueAmount || null,
        previousLoanId: this.props.previousLoanId || null,
        ...(isFlexi && { flexiConfig: JSON.stringify(this.state.flexiBlocksUsed || []) }),
      };
      // ...rest unchanged (axios.post to /loan/postLoan)

       const LoanSettings = getSecureItem("LoanSettings");
      if(LoanSettings?.autoApprove){
        this.state.userdetails.approvalDate = this.state.SelectedDate;
        this.state.userdetails.disbursedDate = this.state.SelectedDate;
      }
       
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ getSecureItem("token")
      }
      // if(this.state.userdetailPostLoan !== " "){
        console.log("this.state.userdetailPostLoan", userdetailPostLoan)
      axios.post(BaseUrl + '/loan/postLoan', userdetailPostLoan, {
        headers: headers,
      }).then(res => {
        console.log("Interest", res)
        if (res.request.status === 200) {
          let custname = this.state.chooseBorrower
          let laontype = this.state.laontype
          if(res.data?.loanId){
            toast.success(laontype + " " + "Assigned Successfully to" + " " + custname, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            });
            const LoanSettings = getSecureItem("LoanSettings");
            if(LoanSettings?.autoApprove){
              this.props.history.push("/customer");
            } else {
              this.props.history.push("/loandisbursement");
            }
          } else {
            // Alert.alert("Warning", res.data?.message)
            toast.error(res.data?.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            });
            
            this.props.history.push("/customer");
          }
        }
      })  
    }
    else{
      if(this.state.collectionagent)
      {
      toast.error("Choose Borrower to Assign Loan!!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      })
    }
    else
    {
      toast.error("Assign to a Collection Agent!!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      })
    }
  }
}

  AllLoanTypeList(callback = () => {}) {
    let loggedinUser = getSecureItem("loggedinUserCompany")

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ getSecureItem("token")
    }
    axios.get(BaseUrl + '/loanType/getAllLoanTypes?loanType=&companyId=' + loggedinUser, {
      headers: headers,
    }).then(resp => {
      if (resp.status === 200) {
        this.setState({ LaonType: resp.data }, callback);
      } else {
        toast.error("Please try again!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      }
    }).catch(err => {
      if (err.request.status !== 200) {
        toast.error("Please try again!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      }
    })
  }

  getAllFees = async () => {
    const companyId = getSecureItem("loggedinUserCompany");
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };

    try {
      const result = await axios.get(
        `${BaseUrl}/feeDetails/getFeeDetails/${companyId}?status=Active`,
        { headers }
      );

      this.setState({ feedetails: result.data || [] }, () => this.recalculateFeesFromLoanAmount());
    } catch (err) {
      this.setState({ feedetails: [] });
    }
  };

  addFeeDetails = () => {
    this.props.history.push('/addFeeDetails?from=AddLoan');
  };

  handleFeeValueChange = (event, fee) => {
    const loanAmount = Number(this.state.amountvalues || 0);
    let amount = 0;

    if (fee.calculation === "Fixed") {
      amount = Number(event.target.value || 0);
    } else if (fee.calculation === "Percentage") {
      amount = Number(event.target.value || 0);
    } else {
      amount = (loanAmount * Number(fee.value)) / 100;
    }

    this.setState(prev => {
      const updated = {
        ...prev.feeValues,
        [fee.name]: amount,
      };

      const total = Object.values(updated).reduce((sum, v) => sum + Number(v || 0), 0);
      updated.totalFee = total;

      return { feeValues: updated, totalFee: total };
    });
  };

  recalculateFeesFromLoanAmount = () => {
    const loanAmount = Number(this.state.amountvalues || 0);
    const updatedFees = {};

    this.state.feedetails.forEach((fee) => {
      if (fee.calculation === "Percentage") {
        updatedFees[fee.name] = Math.round((loanAmount * Number(fee.value)) / 100 * 100) / 100;
      } else if (fee.calculation === "Fixed") {
        updatedFees[fee.name] = Math.round(Number(fee.value) * 100) / 100;
      }
    });

    const total = Object.values(updatedFees).reduce((sum, v) => sum + Number(v || 0), 0);
    updatedFees.totalFee = Math.round(total * 100) / 100;

    this.setState({
      feeValues: updatedFees,
      totalFee: updatedFees.totalFee,
    });
  };

  clear() {
    this.setState({
      collectionAmount:"",
      SelectedDate: new Date(),
      monthlyRange: "",
      weeklyRange: "none",
      dailyRange: "none",
      minValue: 0,
      maxValue: 0,
      step: 1,
      mintenureValue: 0,
      maxtenureValue: 0,
      steptenure: 1,
      mininterestValue: 0,
      maxinterestValue: 0,
      stepinterest: 1,
      laontype: "",
      amountfrom: 0,
      amountto: 0,      
      mintenureMonthValue: 0,
      maxtenureMonthValue: 0,
      tenure: "Monthly",
      collectionagent: "",
      valueAftermoratorium: "",
      chooseBorrower: "",
      amountvalues: 0,
      tenurevalues: 0,
      interestvalues: 0,
      processFee: "",
      feedetails: [],
      feeValues: {},
      totalFee: 0,
      moratorium:"",
      rows: [],
      isdisabled:true,
      scheduleArr:[],
      searchdone:false
    })
    this.props.TableData([],"",true);
  }
  componentWillReceiveProps=(nextProps)=>{
    this.setState({
      collectionagent:nextProps.collectionagent
    })
  }

  render() {
    const currency = getSecureItem("country")?.symbol;
    let countryCurrencySymbol = currency;
    const { t } = this.props;

    const { brands, tenure, searchdone, previousOverDueAmount } = this.state;
    const { chooseBorrower, chooseCoApplicant, chooseGuarantor } = this.state;
    return (
      <div>
        <div className="addloaninterestcomponent">
          <Card className="cardDiv">
            <div className="previewComponent">
              <form onSubmit={(e) => this._handleSubmit(e)}>
                <div className="rowColumn">
                  <div className="rowColumn50100">
                    <div className="textFieldStyle Loan">
                      <h6 className="InputLabel Fonts SizeFont">
                        {t("AddLoanType.Type")}
                      </h6>
                      <TextField
                        id="standard-select-currency"
                        select
                        className="incomefield"
                        value={this.state.laontype || ""}
                        style={{
                          border: this.state.annual,
                          width: "80%",
                          height: "35px",
                          border: "1px solid rgb(212, 212, 213)",
                          borderRadius: "5px",
                        }}
                        onClick={this.annualBox}
                        onChange={this.LoanChange}
                      >
                        {this.state.LaonType.map((option) => (
                          <MenuItem
                            key={option.loanTypeId}
                            value={option.loanType}
                          >
                            {option.loanType}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>

                    {/* <div className="textFieldStyle">
                      <h6 className="InputLabel Fonts SizeFont">penalty</h6>
                      <Input className="textBox" placeholder="Penaly Charges on Default" style={{ height: '35px', border: this.state.changeColoremail }} onClick={this.emailBox} onChange={(event) => this.setState({ fees: event.target.value })} />
                    </div> */}
                    <div className="textFieldStyle" style={{ width: "95%" }}>
                      <h6 className="InputLabel Fonts SizeFont">
                        {" "}
                        {t("AddLoan.loandate")}
                      </h6>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          id="date-picker-inline"
                          value={this.state.SelectedDate}
                          onChange={this.handleDateChange.bind(this)}
                          KeyboardButtonProps={{ "aria-label": "change date" }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    {this.props.method !== "Flexi EMI" && (<div className="textFieldStyle">
                      <div style={{ display: "flex" }}>
                        <h6 className="InputLabel Fonts SizeFont">
                          {" "}
                          {t("AddLoan.moratorm")}
                        </h6>
                        <select
                          disabled
                          onChange={this.searchSubmit}
                          name="test1"
                          id="test1"
                          className="monthlySelect"
                        >
                          {brands.map((brand) => (
                            <option value={brand.id} key={brand.id}>
                              {brand.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <Input
                        type="number"
                        className="numaricTextField"
                        value={this.state.moratorium}
                        style={{
                          height: "35px",
                          border: this.state.changeColoremail4,
                        }}
                        onClick={this.emailBox4}
                        onChange={this.onMoratoriumChange}
                      />
                    </div>)}
                    {this.props.method !== "Flexi EMI" && (<div className="textFieldStyle">
                      <h6 className="InputLabel Fonts SizeFont">
                        {" "}
                        {t("AddLoan.value")}
                      </h6>
                      <Input
                        className="textBox"
                        value={this.state.valueAftermoratorium || ""}
                        style={{
                          height: "35px",
                          border: this.state.changeColoremail3,
                        }}
                        disabled
                      />
                    </div>)}
                    {this.props.previousOverDueAmount &&
                      <div style={{ flex: 1, minWidth: "150px" }}>
                        <h6 className="InputLabel Fonts SizeFont">{"Previous loan over due amount"}</h6>
                        <div
                          style={{
                            height: "35px",
                            border: this.state.changeColoremail3,
                            display: "flex",
                          }}
                          className="textBox"
                        >
                          <span className="aboutfield">{countryCurrencySymbol}</span>
                          <Input
                            type="number"
                            style={{ height: "clamp(26px, 2.8vw, 33px)", fontSize: "clamp(11px, 1.4vw, 14px)" }}
                            value={this.props.previousOverDueAmount || ""}
                            disabled
                          />
                        </div>
                      </div>
                    }
                    <div
                      className="textFieldStyle"
                      style={{ display: this.state.chooseBorrower }}
                    >
                      <h6 className="InputLabel Fonts SizeFont">
                        {t("AddLoan.customer")}
                      </h6>
                      <div
                        ref={this.borrowerWrapperRef}
                        style={{ position: "relative" }}
                      >
                        <div
                          style={{
                            height: "35px",
                            border: this.state.changeColoremail5,
                          }}
                          className="textBox"
                        >
                          <Input
                            list="browsers"
                            className="textBox"
                            placeholder="Choose Borrower"
                            value={chooseBorrower || ""}
                            onClick={this.emailBox5}
                            onChange={(e) => this.handleCustomerInputChange(e, "Borrower")}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                event.preventDefault();
                                this.triggerCustomerSearch("Borrower");
                              }
                            }}
                            disabled={
                              this.props?.location?.params?.customerId
                                ? true
                                : false
                            }
                            onBlur={() => {
                              if (!this.state.customerId) {
                                this.setState({ searchdoneBorrower: true });
                              }
                            }}
                          />
                          <IconButton
                            size="small"
                            onMouseDown={(event) => event.preventDefault()}
                            onClick={() => this.triggerCustomerSearch("Borrower")}
                            style={{ padding: "4px" }}
                          >
                            <img src={searchicon} alt="search" style={{ width: 16, height: 16 }} />
                          </IconButton>
                        </div>
                        {this.renderDropdown(this.state.allBorrower, "Borrower")}
                      </div>
                    </div>
                    {this.props.method === "Flexi EMI" && (<Card
                      className="feeCard"
                      style={{
                        padding: "15px",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <div className='feeCardHeader'>
                        <h6 className="feeLabel">Additional Fees</h6>

                        <span
                          onClick={this.addFeeDetails}
                          style={{
                            cursor: "pointer",
                            color: "#1976d2",
                            textDecoration: "underline",
                            fontSize: "14px",
                            fontWeight: "500",
                            paddingRight: "4px",
                          }}
                        >
                          + Add Fee
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                          gap: "15px",
                          width: "100%",
                          maxHeight: "220px",
                          overflowY: this.state.feedetails.length > 6 ? "auto" : "visible",
                          paddingRight: "5px",
                          marginBottom: "25px"
                        }}
                      >
                        {this.state.feedetails.map((fee) => (
                          <div key={fee.feeId} style={{ minWidth: "180px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#8E8E98",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {fee.name} ({fee.calculation})
                            </label>

                            <div className="feeInputContainer">
                              <span>{countryCurrencySymbol}</span>
                              <input
                                type="number"
                                value={this.state.feeValues?.[fee.name] || ""}
                                onChange={(e) => this.handleFeeValueChange(e, fee)}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </Card>)}
                    {(getSecureItem("loggedinUserCompany") === 2749) && (
                      <div
                        className="textFieldStyle"
                        style={{ display: this.state.chooseCoApplicant }}
                      >
                        <h6 className="InputLabel Fonts SizeFont">
                          {t("AddLoan.coApplicant")}
                        </h6>
                        <div
                          ref={this.coApplicantWrapperRef}
                          style={{ position: "relative" }}
                        >
                          <div
                            style={{
                              height: "35px",
                              border: this.state.changeColoremail6,
                              display: "flex",
                              alignItems: "center",
                            }}
                            className="textBox"
                          >
                            <Input
                              list="browsers"
                              className="textBox"
                              placeholder="Choose Co Applicant"
                              value={chooseCoApplicant || ""}
                              onClick={this.emailBox6}
                              onChange={(e) => this.handleCustomerInputChange(e, "CoApplicant")}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  this.triggerCustomerSearch("CoApplicant");
                                }
                              }}
                              disabled={
                                this.props?.location?.params
                                  ?.coApplicantCustomerId
                                  ? true
                                  : false
                              }
                              onBlur={() => {
                                if (!this.state.coApplicantCustomerId) {
                                  this.setState({ searchdoneCoApplicant: true });
                                }
                              }}
                            />
                            <IconButton
                              size="small"
                              onMouseDown={(event) => event.preventDefault()}
                              onClick={() => this.triggerCustomerSearch("CoApplicant")}
                              style={{ padding: "4px" }}
                            >
                              <img src={searchicon} alt="search" style={{ width: 16, height: 16 }} />
                            </IconButton>
                          </div>
                          {this.renderDropdown(
                            this.state.allCoApplicant,
                            "CoApplicant"
                          )}
                        </div>
                      </div>
                    )}

                    {(getSecureItem("loggedinUserCompany") === 2749) && (
                      <div
                        className="textFieldStyle"
                        style={{ display: this.state.guarantor }}
                      >
                        <h6 className="InputLabel Fonts SizeFont">
                          {t("AddLoan.guarantor")}
                        </h6>
                        <div
                          ref={this.guarantorWrapperRef}
                          style={{ position: "relative" }}
                        >
                          <div
                            style={{
                              height: "35px",
                              border: this.state.changeColoremail7,
                              display: "flex",
                              alignItems: "center",
                            }}
                            className="textBox"
                          >
                            <Input
                              list="browsers"
                              className="textBox"
                              placeholder="Choose Guarantor"
                              value={chooseGuarantor || ""}
                              onClick={this.emailBox7}
                              onChange={(e) => this.handleCustomerInputChange(e, "Guarantor")}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  this.triggerCustomerSearch("Guarantor");
                                }
                              }}
                              disabled={
                                this.props?.location?.params
                                  ?.coGuarantorCustomerId
                                  ? true
                                  : false
                              }
                              onBlur={() => {
                                if (!this.state.guarantorCustomerId) {
                                  this.setState({ searchdoneGuarantor: true });
                                }
                              }}
                            />
                            <IconButton
                              size="small"
                              onMouseDown={(event) => event.preventDefault()}
                              onClick={() => this.triggerCustomerSearch("Guarantor")}
                              style={{ padding: "4px" }}
                            >
                              <img src={searchicon} alt="search" style={{ width: 16, height: 16 }} />
                            </IconButton>
                          </div>
                          {this.renderDropdown(
                            this.state.allGuarantor,
                            "Guarantor"
                          )}
                        </div>
                      </div>
                    )}
                    {/* <div style={{ marginTop: "6rem" }}>
                      <Button className="savebutton btnSizeFont Fonts" onClick={this.betweenRange}>
                         {t('AddLoan.buttn1')}
                      </Button>
                      <Button className="cancelbutton btnSizeFont Fonts" onClick={this.clear.bind(this)}>
                         {t('AddLoan.buttn2')}
                      </Button>
                    </div> */}
                  </div>
                  <div className="rowColumn50100 mt2">
                    <div style={{ display: "flex", width: "80%" }}>
                      <h6 className="InputLabel Fonts SizeFont">
                        {" "}
                        {t("AddLoan.amount")}
                      </h6>
                      <div
                        className="outputDivLoan"
                        style={{ display: "flex" }}
                      >
                        <div style={{ paddingTop: "7px" }}>
                          {countryCurrencySymbol}
                        </div>{" "}
                        <Input
                          className="output"
                          value={this.state.amountvalues}
                          margin="dense"
                          onChange={this.handleInputChange}
                          onBlur={this.handleBlur}
                          inputProps={{
                            type: "number",
                            "aria-labelledby": "input-slider",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        width: "80%",
                      }}
                    >
                      <Slider
                        value={
                          typeof this.state.amountvalues === "number"
                            ? this.state.amountvalues
                            : null
                        }
                        min={this.state.minValue}
                        step={this.state.step}
                        max={this.state.maxValue}
                        onChange={this.handleSliderChange}
                        aria-labelledby="input-slider"
                      />
                      <div className="rangeLoan">
                        <span className="Money Fonts">
                          {this.state.minValue} {countryCurrencySymbol}
                        </span>
                        <span className="Fonts Money">
                          {this.state.maxValue} {countryCurrencySymbol}
                        </span>
                      </div>
                    </div>
                    <br></br>
                    <div
                      style={{ display: "flex", width: "80%" }}
                      className="rowColumn"
                    >
                      <h6 className="InputLabel Fonts SizeFont">
                        {" "}
                        {t("AddLoan.tenure")}
                      </h6>
                      <select
                        disabled
                        onChange={this.searchSubmit}
                        name="test2"
                        id="test2"
                        className="monthlySelect"
                      >
                        {brands.map((brand) => (
                          <option value={brand.id} key={brand.id}>
                            {brand.name}
                          </option>
                        ))}
                      </select>
                      <div className="outputDivLoan">
                        <Input
                          className="output"
                          value={this.state.tenurevalues}
                          margin="dense"
                          onChange={this.handleInputtenureChange}
                          inputProps={{
                            step: 3,
                            min: 3,
                            max: 20,
                            type: "number",
                            "aria-labelledby": "input-slider",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        width: "80%",
                      }}
                    >
                      <Slider
                        value={
                          typeof this.state.tenurevalues === "number"
                            ? this.state.tenurevalues
                            : null
                        }
                        max={this.state.maxtenureValue}
                        min={this.state.mintenureValue}
                        step={this.state.steptenure}
                        onChange={this.handleSlidertenureChange}
                        aria-labelledby="input-slider"
                      />
                      <div className="rangeLoan">
                        <span
                          className=" Money Fonts"
                          style={{ display: this.state.monthlyRange }}
                        >
                          {this.state.mintenureMonthValue} Months
                        </span>
                        <span
                          className="Fonts Money"
                          style={{ display: this.state.monthlyRange }}
                        >
                          {this.state.maxtenureMonthValue} Months
                        </span>
                        <span
                          className="Money Fonts"
                          style={{ display: this.state.weeklyRange }}
                        >
                          {this.state.mintenureWeekValue} Weeks
                        </span>
                        <span
                          className="Fonts Money"
                          style={{ display: this.state.weeklyRange }}
                        >
                          {this.state.maxtenureWeekValue} Weeks
                        </span>
                        <span
                          className="Money Fonts"
                          style={{ display: this.state.dailyRange }}
                        >
                          {this.state.mintenureDaysValue} Days
                        </span>
                        <span
                          className="Fonts Money"
                          style={{ display: this.state.dailyRange }}
                        >
                          {this.state.maxtenureDaysValue} Days
                        </span>
                      </div>
                    </div>
                    <br></br>
                    <div style={{ display: "flex", width: "80%" }}>
                      <h6 className="InputLabel Fonts SizeFont">
                        {t("AddLoan.emi")}{" "}
                      </h6>
                      <div className="outputDivLoan">
                        <Input
                          className="output"
                          value={this.state.interestvalues}
                          margin="dense"
                          onChange={this.handleInputinterestChange}
                          inputProps={{
                            step: 11,
                            min: 11,
                            max: 21,
                            type: "number",
                            "aria-labelledby": "input-slider",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        width: "80%",
                      }}
                    >
                      <Slider
                        value={
                          typeof this.state.interestvalues === "number"
                            ? this.state.interestvalues
                            : null
                        }
                        max={this.state.maxinterestValue}
                        min={this.state.mininterestValue}
                        step={this.state.stepinterest}
                        onChange={this.handleSliderinterestChange}
                        aria-labelledby="input-slider"
                      />
                      <div className="rangeLoan">
                        <span className="Money Fonts">
                          {this.state.mininterestValue}
                        </span>
                        <span className="Fonts Money">
                          {this.state.maxinterestValue}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "15px",
                        alignItems: "flex-end",
                        flexWrap: "wrap",
                        width: "100%",
                        maxWidth: "630px",
                      }}
                    >
                      <div style={{ flex: 1, minWidth: "150px", maxWidth: "clamp(150px, 30vw, 260px)" }}>
                        <h6 className="InputLabel Fonts SizeFont">
                          {"Processing Fee"}
                        </h6>
                        <div
                          style={{
                            height: "35px",
                            border: this.state.changeColoremail3,
                            display: "flex",
                          }}
                          className="textBox"
                        >
                          <span className="aboutfield">
                            {countryCurrencySymbol}
                          </span>
                          <Input
                            type="number"
                            onClick={this.emailBox3}
                            value={this.state.processFee || ""}
                            onChange={(event) => {
                              this.setState({
                                processFee: event.target.value,
                                isdisabled: true,
                                rows: [],
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {this.props.method !== "Flexi EMI" && (<Card
                      className="feeCard"
                      style={{
                        padding: "15px",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <div className='feeCardHeader'>
                        <h6 className="feeLabel">Additional Fees</h6>

                        <span
                          onClick={this.addFeeDetails}
                          style={{
                            cursor: "pointer",
                            color: "#1976d2",
                            textDecoration: "underline",
                            fontSize: "14px",
                            fontWeight: "500",
                            paddingRight: "4px",
                          }}
                        >
                          + Add Fee
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                          gap: "15px",
                          width: "100%",
                          maxHeight: "220px",
                          overflowY: this.state.feedetails.length > 6 ? "auto" : "visible",
                          paddingRight: "5px",
                          marginBottom: "25px"
                        }}
                      >
                        {this.state.feedetails.map((fee) => (
                          <div key={fee.feeId} style={{ minWidth: "180px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#8E8E98",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {fee.name} ({fee.calculation})
                            </label>

                            <div className="feeInputContainer">
                              <span>{countryCurrencySymbol}</span>
                              <input
                                type="number"
                                value={this.state.feeValues?.[fee.name] || ""}
                                onChange={(e) => this.handleFeeValueChange(e, fee)}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </Card>)}
                    <br></br>
                    {/* <div className="TotalMoneyDisplay">
                      <input placeholder={countryCurrencySymbol} value={this.state.collectionAmount || ""} className="displaytotalmoney" disabled style={{ backgroundColor: "transparent" }} />
                    </div>
                    <span className="Fonts instalment">{t('AddLoan.instal')}</span> */}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginLeft: "5%",
                    marginRight: "5%",
                    marginTop: "5%",
                  }}
                  className="rowColumn"
                >
                  <div
                    className="rowColumn"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      className="savebutton btnSizeFont Fonts"
                      onClick={this.betweenRange}
                    >
                      {t("AddLoan.buttn1")}
                    </Button>
                    <Button
                      className="cancelbutton btnSizeFont Fonts"
                      onClick={this.clear.bind(this)}
                    >
                      {t("AddLoan.buttn2")}
                    </Button>
                  </div>
                  {(() => {
                    const distAmount = parseFloat(this.state.amountvalues) || 0;
                    const processFee = parseFloat(this.state.processFee) || 0;
                    const installment = parseFloat(this.state.collectionAmount) || 0;
                    const tenurevalues = parseFloat(this.state.tenurevalues) || 0;
                    const totalAmount = installment * tenurevalues;

                    let addOnFeeTotal = 0;
                    let deductableFeeTotal = 0;

                    this.state.feedetails.forEach((fee) => {
                      const feeAmount = parseFloat(this.state.feeValues?.[fee.name]) || 0;
                      if (fee.category === "Add-On Fee") {
                        addOnFeeTotal += feeAmount;
                      } else if (fee.category === "Deductable Fee") {
                        deductableFeeTotal += feeAmount;
                      }
                    });

                    let cashGiven = distAmount - processFee - deductableFeeTotal;
                    if (previousOverDueAmount) {
                      cashGiven = cashGiven - previousOverDueAmount;
                    }
                    const profit = this.props.method === "Flexi EMI" ? this.state.totalInterest : (totalAmount - distAmount + deductableFeeTotal + processFee);

                    return (
                      <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                        <div className="mt2" style={{ textAlign: "center" }}>
                          <div className="TotalMoney">
                            <input
                              placeholder={countryCurrencySymbol}
                              value={cashGiven ? cashGiven.toFixed(2) : ""}
                              className="displaytotalmoney"
                              disabled
                              style={{ backgroundColor: "transparent", textAlign: "center" }}
                            />
                          </div>
                          <span className="Fonts instalment" style={{ display: "block", textAlign: "center" }}>
                            Cash Given
                          </span>
                        </div>
                        <div className="mt2" style={{ textAlign: "center" }}>
                          <div className="TotalMoney">
                            <input
                              placeholder={countryCurrencySymbol}
                              value={profit ? profit.toFixed(2) : ""}
                              className="displaytotalmoney"
                              disabled
                              style={{ backgroundColor: "transparent", textAlign: "center" }}
                            />
                          </div>
                          <span className="Fonts instalment" style={{ display: "block", textAlign: "center" }}>
                            Profit
                          </span>
                        </div>

                        <div className="mt2" style={{ textAlign: "center" }}>
                          <div className="TotalMoney">
                            <input
                              placeholder={countryCurrencySymbol}
                              value={this.state.collectionAmount || ""}
                              className="displaytotalmoney"
                              disabled
                              style={{ backgroundColor: "transparent", textAlign: "center" }}
                            />
                          </div>
                          <span className="Fonts instalment" style={{ display: "block", textAlign: "center" }}>
                            {t("AddLoan.instal")}
                          </span>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </form>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}
export default withNamespaces()(withRouter(AddLoan));
